import React, { useCallback, useState } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { isMultiMediaDeviation } from '../../DeviationViews/_helpers';
import { useZoomBiLogger } from '../../DeviationViews/Full/hooks/useZoomBiLogger';
import { DefaultArtStageProps as Props } from '../types';
import DesktopMultiArtStage from './DesktopMultiArtStage';
import DesktopSingleArtStage from './DesktopSingleArtStage';
import { DeviantMediaWrapper } from '../../utils/DeviationMediaService/types';

export const DesktopArtStage: React.FC<Props> = props => {
  const isMultiVideoFlagEnabled = useFlag('multi_video');
  const hasAdditionalMedia = props.deviation.extended?.additionalMedia?.length;
  const shouldRenderMultiImage =
    isMultiMediaDeviation(props.deviation, isMultiVideoFlagEnabled) && hasAdditionalMedia;

  const [zoomedImageSource, setZoomedImageSource] = useState<DeviantMediaWrapper | undefined>();

  const logZoomBi = useZoomBiLogger(props.deviation);

  const onEnterZoomMode = useCallback(
    source => {
      setZoomedImageSource(source);
      logZoomBi(true);
    },
    [logZoomBi]
  );

  const onExitZoomMode = useCallback(() => {
    setZoomedImageSource(undefined);
    logZoomBi(false);
  }, [logZoomBi]);

  const isZoomed = !!zoomedImageSource;

  return shouldRenderMultiImage ? (
    <DesktopMultiArtStage
      {...props}
      isZoomed={isZoomed}
      zoomedImageSource={zoomedImageSource}
      onEnterZoomMode={onEnterZoomMode}
      onExitZoomMode={onExitZoomMode}
    />
  ) : (
    <DesktopSingleArtStage
      {...props}
      isZoomed={isZoomed}
      zoomedImageSource={zoomedImageSource}
      onEnterZoomMode={onEnterZoomMode}
      onExitZoomMode={onExitZoomMode}
    />
  );
};
DesktopArtStage.displayName = 'DesktopArtStage';
export default DesktopArtStage;
